<template>
    <div class="sustainability-page-ratings">
        <div class="container">
            <z-caption
                tag="a"
                size="3xl"
                href="/sustainability/assessment/"
                decor-left
                decor-right
                class="sustainability-page-ratings__title sustainability-page__title"
            >
                <span v-html="text.title" />
            </z-caption>
            <div class="sustainability-page-ratings__body">
                <div class="sustainability-page-ratings__row row">
                    <div
                        v-for="(rating, index) in ratings"
                        :key="index"
                        class="sustainability-page-ratings__col col-default-3 col-tablet-6 col-v-tablet-12"
                    >
                        <div class="sustainability-page-ratings__item">
                            <div class="sustainability-page-ratings__rating">
                                <div class="sustainability-page-ratings__rating-value">
                                    <z-tooltip :content="rating.tooltip">
                                        <span
                                            class="sustainability-page-ratings__rating-inner"
                                            v-html="rating.value"
                                        ></span>
                                    </z-tooltip>
                                </div>
                                <span
                                    class="sustainability-page-ratings__rating-level"
                                    v-html="rating.level"
                                ></span>
                            </div>
                            <div class="sustainability-page-ratings__rating-image">
                                <img
                                    :src="rating.image"
                                    :alt="rating.title"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="sustainability-page-ratings__line">
            <div class="sustainability-page-ratings__line-list">
                <div
                    v-for="(item, index) in initiatives"
                    :key="index"
                    class="sustainability-page-ratings__line-item"
                >
                    <img
                        :src="item.image"
                        :alt="item.name"
                    />
                </div>
            </div>
            <div class="sustainability-page-ratings__line-list sustainability-page-ratings__line-list--twin">
                <div
                    v-for="(item, index) in initiatives"
                    :key="index"
                    class="sustainability-page-ratings__line-item"
                >
                    <img
                        :src="item.image"
                        :alt="item.name"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'sustainability-page-ratings',
    data () {
        return {
            ratings: [
                {
                    title: 'Ecovadis',
                    value: '58<span class="small">/100</span>',
                    level: localize({
                        ru: 'ESG-рейтинг',
                        en: 'ESG Rating'
                    }),
                    tooltip: localize({
                        ru: '58&nbsp;баллов из&nbsp;100. Февраль 2024г.',
                        en: '58&nbsp;points out of&nbsp;100. February 2024.'
                    }),
                    image: '/images/sustainability/new/ecovadis.svg'
                },
                {
                    title: 'Rating Review',
                    value: 'A',
                    level: localize({
                        ru: 'ESG-рейтинг',
                        en: 'ESG Rating'
                    }),
                    tooltip: localize({
                        ru: 'Высокий уровень управления ESG рисками. Октябрь 2024&nbsp;г.',
                        en: 'High level of&nbsp;ESG risk management. October 2024.'
                    }),
                    image: '/images/sustainability/new/rr.svg'
                },
                {
                    title: 'AKPA',
                    value: 'ESG-B',
                    level: localize({
                        ru: 'уровень ESG-2',
                        en: 'ESG Level 2'
                    }),
                    tooltip: localize({
                        ru: 'Соответствует очень высокой оценке в&nbsp;области экологии, социальной ответственности и&nbsp;управления. Сентябрь 2024г.',
                        en: 'Corresponds to&nbsp;a&nbsp;very high rating in&nbsp;the areas of&nbsp;environment, social responsibility, and governance. September 2024.'
                    }),
                    image: '/images/sustainability/new/akpa.svg'
                },
                {
                    title: 'Expert',
                    value: 'ESG-III (a)',
                    level: localize({
                        ru: 'уровень a',
                        en: 'Level A'
                    }),
                    tooltip: localize({
                        ru: 'Очень высокий уровень соблюдения интересов в&nbsp;области устойчивого развития при принятии ключевых решений. Сентябрь 2024&nbsp;г.',
                        en: 'Very high level of&nbsp;consideration for sustainable development interests in&nbsp;key decision-making. September 2024.'
                    }),
                    image: '/images/sustainability/new/expert.svg'
                }
            ],
            initiatives: [
                {
                    name: 'UN Global Compact',
                    image: '/images/sustainability/new/un-global-compact.webp'
                },
                {
                    name: 'International Platinum Group',
                    image: '/images/sustainability/new/ipa.webp'
                },
                {
                    name: 'Global Battery Alliance',
                    image: '/images/sustainability/new/gba.webp'
                },
                {
                    name: 'Nickel Institute',
                    image: '/images/sustainability/new/nickel.webp'
                },
                {
                    name: 'GRI',
                    image: '/images/sustainability/new/gri.webp'
                },
                {
                    name: 'ISO',
                    image: '/images/sustainability/new/iso.webp'
                }
            ],
            text: {
                title: localize({
                    ru: 'ESG-рейтинги и&nbsp;инициативы',
                    en: 'ESG Ratings and Initiatives'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.sustainability-page-ratings {
    --list-gap: 204px;
    padding-bottom: 146px;

    @include breakpoint(laptop) {
        --list-gap: #{$token-spacers-4-xl};
        padding-bottom: $token-spacers-3-xl;
    }

    @include breakpoint(tablet) {
        --list-gap: #{$token-spacers-2-xl};
        padding-bottom: $token-spacers-l;
    }

    @include breakpoint(v-tablet) {
        --list-gap: #{$token-spacers-m};
        padding-bottom: $token-spacers-s;
    }

    @include breakpoint(mobile) {
        --list-gap: 22px;
        padding-bottom: 0;
    }

    &__body {
        padding-top: $token-spacers-2-s;

        @include breakpoint(mobile) {
            padding-top: 0;
        }
    }

    &__row {
        @include breakpoint(mobile) {
            margin-top: -24px !important;
        }
    }

    &__col {
        @include breakpoint(mobile) {
            margin-top: 24px !important;
        }
    }

    &__item {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        padding-top: 10px;

        @include breakpoint(mobile) {
            gap: 16px;
            padding-top: 0;
        }
    }

    &__rating {
        display: flex;
        flex-direction: column;
        color: #004589;
    }

    &__rating-value {
        width: fit-content;
        font-size: 40px;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.4px;
        margin: 0;
        position: relative;

        @include breakpoint(tablet) {
            font-size: 32px;
        }

        @include breakpoint(mobile) {
            font-size: 26px;
        }

        .small {
            font-size: 32px;
            color: #5487B9;
            vertical-align: top;
            margin: 0 0 0 10px;

            @include breakpoint(tablet) {
                font-size: 28px;
            }

            @include breakpoint(mobile) {
                font-size: 24px;
            }
        }

        .z-tooltip__icon {
            position: absolute;
            top: -10px;
            right: -24px;

            @include breakpoint(mobile) {
                top: 0;
                right: -22px;
            }

            path {
                fill: #016CB6;
            }
        }
    }

    &__rating-inner {
        margin: 0 !important;
    }

    &__rating-level {
        font-size: 20px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: -0.2px;

        @include breakpoint(mobile) {
            font-size: 18px;
        }
    }

    &__rating-image {
        width: 100%;
        min-height: 102px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px 20px 20px 0px;
        background: $token-colors-navy-blue;
        padding: $token-spacers-xs;

        @include breakpoint(v-tablet) {
            max-height: 80px;
            min-height: 0;
        }

        @include breakpoint(mobile) {
            max-height: 56px;
            padding: $token-spacers-2-xs $token-spacers-xs;
        }

        img {
            max-width: 100%;
            height: auto;

            @include breakpoint(v-tablet) {
                max-height: 32px;
            }

            @include breakpoint(mobile) {
                max-height: 24px;
            }
        }
    }

    &__line {
        display: flex;
        align-items: center;
        gap: var(--list-gap);
        margin-top: 96px;
        overflow-x: hidden;

        @include breakpoint(tablet) {
            margin-top: $token-spacers-l;
        }

        @include breakpoint(mobile) {
            margin-top: $token-spacers-xs;
        }
    }

    &__line-list {
        display: flex;
        align-items: center;
        gap: var(--list-gap);
        animation: runningLine 50s linear infinite;
    }

    &__line-item {
        width: 140px;
        display: flex;
        aspect-ratio: 1;

        @include breakpoint(tablet) {
            width: 120px;
        }

        @include breakpoint(mobile) {
            width: 96px;
        }

        img {
            max-width: 100%;
            height: auto;
        }
    }
}

@keyframes runningLine {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(calc(-100% - var(--list-gap)))
    }
}
</style>
